import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/images/new/onlinecare_jumbotron.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-206b277b")

_pushScopeId("data-v-206b277b")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 만성·일반질환 ")
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "-royalBlue" }, "온라인 대면진료(처방전)", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 고혈압, 당뇨 등 만성질환자, 감기 등 일반질환 진료 ")
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 예약일에 화상으로 의사면담 후 처방전 발급 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("진료 예약")
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "Online Care"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Jumbotorn = _resolveComponent("Jumbotorn")

  return (_openBlock(), _createBlock(_component_Jumbotorn, { class: "onlinecare-intro" }, {
    header: _withId(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    main: _withId(() => [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5
    ]),
    footer: _withId(() => [
      _createVNode(_component_router_link, {
        to: _ctx.linkTo,
        class: "-button -royalBlue -bold"
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    image: _withId(() => [
      _createVNode("figure", {
        class: !!_ctx.isMobileShow ? '' : '-pc'
      }, [
        _hoisted_7
      ], 2)
    ]),
    _: 1
  }))
})